import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon, eyeIcon } from '../../../config/variables';

const PagesTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: any) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header: any, index: number) => (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item: any, index: number) => (
              <div className="item has_logo fuel_types" key={index}>
                <div className="column">
                  <div className="capitalize">{item?.name || '-'}</div>
                </div>
                {/* {hasPermission(['fuel-types.edit']) && ( */}
                <div className="column actions actions_col">
                  <div
                    className="action_btn edit"
                    onClick={(e) => {
                      const contentContainer = document.querySelector('.layout_content');
                      contentContainer?.scrollTo({ top: 0, behavior: 'smooth' });
                      e.stopPropagation();
                      navigate(`/pages/page-sections/${item.id}`);
                    }}
                  >
                    {eyeIcon}
                  </div>
                  <div
                    className="action_btn edit"
                    onClick={(e) => {
                      const contentContainer = document.querySelector('.layout_content');
                      contentContainer?.scrollTo({ top: 0, behavior: 'smooth' });
                      e.stopPropagation();
                      navigate(`/pages/create-page/${item.id}`);
                    }}
                  >
                    {editIcon}
                  </div>
                </div>
                {/* )} */}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default PagesTableContainer;
